import {ACTION_CODE} from './_actionCode';
import {ExpenseAttachmentService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DOWNLOAD_EXPENSE_ATTACHMENT';

export async function downloadExpenseAttachment(userData: Record<string, any>, reportId: string) {
    try {
        LoggerService.logInfo('Action - downloadExpenseAttachment - Start');

        const getAllExpenseAttachmentResult = await ExpenseAttachmentService.downloadExpenseAttachment(userData, reportId);

        LoggerService.logInfo('Action - downloadExpenseAttachment - End - Success');

        return ResultModel.newSuccessResult(getAllExpenseAttachmentResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - downloadExpenseAttachment - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
